import { Component, OnDestroy, OnInit } from '@angular/core';
import { SearchFormComponent } from '../../module/catalog/components/search-form/search-form.component';
import { RealtyService } from '../../module/catalog/services/realty.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    SearchFormComponent,
    SearchFormComponent,
    SearchFormComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy  {

  constructor(private realtyService: RealtyService) {}
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
